import { put, takeLatest, all, call } from "redux-saga/effects";
import { setLoading, removeLoading } from "../../utils";
import { post, get, put as putCall } from "../../api";
import {
  ADD_SALON,
  GET_SALON_SERVICES,
  GET_SALON_SERVICES_SUCCESS,
  ADD_SALON_SERVICE,
  GET_SALON_ALL_APPOINTMENTS,
  GET_SALON_ALL_APPOINTMENTS_SUCCESS,
  CONFIRM_APPOINTMENTS,
  DECLINE_APPOINTMENTS,
  EDIT_SERIVCE,
  UPDATE_SALON,
  ADD_SALON_IMAGE,
  ADD_SALON_IMAGE_SUCCESS,
  COMPLETE_APPOINTMENT,
  GENERATE_BILL,
  ADD_LOGO_IMAGE,
} from "../constants";
import { VIEW_SERVICES, SALON_ONBOARDING } from "../../constants";
import {
  ADD_UPDATE_SALON as ADD_UPDATE_SALON_API,
  GET_SERVICES as GET_SERVICES_API,
  BOOK_CANCEL_APPOINTMENT as BOOK_CANCEL_APPOINTMENT_API,
  ADD_EDIT_SERVICE as ADD_EDIT_SERVICE_API,
  SALON_ALL_APPOINTMENTS as SALON_ALL_APPOINTMENTS_API,
  CONFIRM_DECLINE_APPOINTMENTS as CONFIRM_DECLINE_APPOINTMENTS_API,
} from "../../api/endpoints";

function* addSalon({ payload }) {
  setLoading();
  const baseApi = `${ADD_UPDATE_SALON_API}`;
  yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  removeLoading();
  window.location.href = `${SALON_ONBOARDING}/images`;
}

function* addSalonImage({ payload: { salon_id, data } }) {
  setLoading();
  const baseApi = `${ADD_UPDATE_SALON_API}/${salon_id}/images`;
  const {
    data: { image_urls },
  } = yield call(putCall, {
    endpoint: baseApi,
    params: data,
  });

  removeLoading();
  yield put({
    type: ADD_SALON_IMAGE_SUCCESS,
    data: image_urls,
  });
}

function* addLogoImage({ payload: { salon_id, data } }) {
  setLoading();
  const baseApi = `${ADD_UPDATE_SALON_API}/${salon_id}/update_logo`;
  const {
    data: { image_urls },
  } = yield call(putCall, {
    endpoint: baseApi,
    params: data,
  });
  window.location.href = `${SALON_ONBOARDING}/images`;
  removeLoading();
}

function* updateSalon({ payload: { payload, salonId, isSalonRegistered } }) {
  setLoading();
  const baseApi = `${ADD_UPDATE_SALON_API}/${salonId}`;
  yield call(putCall, {
    endpoint: baseApi,
    params: payload,
  });
  removeLoading();
  if (window.location.pathname === "/salon-onboarding/address") {
    window.location.href = `${SALON_ONBOARDING}/images`;
    return;
  }
  if (
    window.location.pathname === "/salon-onboarding/discounts" &&
    isSalonRegistered
  ) {
    window.location.href = `/`;
    return;
  }
  if (!isSalonRegistered) {
    return;
  }
}

function* getSalonServices() {
  setLoading();
  const baseApi = `${GET_SERVICES_API}`;
  const salonServices = yield call(get, baseApi);
  removeLoading();
  yield put({
    type: GET_SALON_SERVICES_SUCCESS,
    data: salonServices.data.categories,
  });
}

function* addSalonServices({ payload }) {
  setLoading();
  const baseApi = `${ADD_EDIT_SERVICE_API}`;
  yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  removeLoading();
  const {
    salon_service: { salon_id },
  } = payload;
  window.location.href = `${VIEW_SERVICES}/${salon_id}`;
}

function* getSalonAllAppointments({ payload: { salonId } }) {
  setLoading();
  const baseApi = `${SALON_ALL_APPOINTMENTS_API}/${salonId}/appointments`;
  const salonAppointments = yield call(get, baseApi);
  removeLoading();
  yield put({
    type: GET_SALON_ALL_APPOINTMENTS_SUCCESS,
    data: salonAppointments.data.appointments,
  });
}

function* confirmAppointments({ payload: { appointmentId, salonId } }) {
  setLoading();
  const baseApi = `${CONFIRM_DECLINE_APPOINTMENTS_API}/${appointmentId}/confirm`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  yield call(getSalonAllAppointments, { payload: { salonId: salonId } });
  removeLoading();
}

function* declineAppointment({ payload: { appointmentId, salonId } }) {
  setLoading();
  const baseApi = `${CONFIRM_DECLINE_APPOINTMENTS_API}/${appointmentId}/decline`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  yield call(getSalonAllAppointments, { payload: { salonId: salonId } });
  removeLoading();
}

function* editService({ payload: { salon_service, serviceId } }) {
  setLoading();
  const baseApi = `${ADD_EDIT_SERVICE_API}/${serviceId}`;
  yield call(putCall, {
    endpoint: baseApi,
    params: { salon_service },
  });
  removeLoading();
  window.history.go(-1);
}

function* completeAppointment({ payload: { appointmentId, salonId } }) {
  setLoading();
  const baseApi = `${BOOK_CANCEL_APPOINTMENT_API}/${appointmentId}/complete`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  removeLoading();
  yield call(getSalonAllAppointments, { payload: { salonId: salonId } });
}

function* generateBill({ payload: { appointmentId, salonId } }) {
  setLoading();
  const baseApi = `${BOOK_CANCEL_APPOINTMENT_API}/${appointmentId}/send_bill`;
  yield call(get, baseApi);
  window.billMessage = "Bill sent successfully to user";
  document.querySelector(".toastButton").click();
  removeLoading();
}

function* actionWatcher() {
  yield takeLatest(ADD_SALON, addSalon);
  yield takeLatest(UPDATE_SALON, updateSalon);
  yield takeLatest(GET_SALON_SERVICES, getSalonServices);
  yield takeLatest(ADD_SALON_SERVICE, addSalonServices);
  yield takeLatest(GET_SALON_ALL_APPOINTMENTS, getSalonAllAppointments);
  yield takeLatest(CONFIRM_APPOINTMENTS, confirmAppointments);
  yield takeLatest(DECLINE_APPOINTMENTS, declineAppointment);
  yield takeLatest(EDIT_SERIVCE, editService);
  yield takeLatest(ADD_SALON_IMAGE, addSalonImage);
  yield takeLatest(ADD_LOGO_IMAGE, addLogoImage);
  yield takeLatest(COMPLETE_APPOINTMENT, completeAppointment);
  yield takeLatest(GENERATE_BILL, generateBill);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
